import { desaturate, tint, adjustHue } from 'polished'

const defaultColors = {
  interactive: '#11921c',
  primary: '#11921c',
  secondary: '#0052ff',

  white: '#ffffff',
  black: '#000000',

  success: '#29a745',
  warning: '#f5a623',
  danger: '#d42918',

  gray50: '#fbfbfc',
  gray100: '#f7f8f8',
  gray200: '#e7e7e8',
  gray300: '#cccdcf',
  gray400: '#a8aaab',
  gray500: '#7e7f80',
  gray600: '#545556',
  gray700: '#303131',
  gray800: '#161717',
  gray900: '#070707'
}

const defaultGradents = {
  light: `linear-gradient(134deg, #e2f6f3 0%, #e7f9e4 100%)`,
  vivid: `linear-gradient(143deg, #408688 0%, #3f745c 100%)`
}

const defaultBranding = {}

const defaultDimensions = {
  leftMenuWidth: 256
}

const buildGradientsFromColor = color => {
  return {
    light: `linear-gradient(134deg, ${tint(0.9, color)}, ${tint(0.8, color)})`,
    vivid: `linear-gradient(143deg, ${desaturate(
      0.4,
      adjustHue(10, color)
    )}, ${desaturate(0.4, adjustHue(-10, color))})`
  }
}

const makeTheme = options => {
  const colors = { ...defaultColors, ...options.colors }
  const gradients = options.gradients
    ? { ...defaultGradents, ...options.gradients }
    : buildGradientsFromColor(colors.interactive)
  const dimensions = { ...defaultDimensions, ...options.dimensions }
  const branding = { ...defaultBranding, ...options.branding }

  return {
    colors,
    gradients,
    dimensions,
    branding,
    card: options.card || {},
  }
}

export default makeTheme({})

export { makeTheme }
